module.exports = __webpack_public_path__ + "static/media/two-sword-logo.ac1d447e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/two-sword-logo.svg
// module id = 249
// module chunks = 0